/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectManagerUpdateParam
 */
export interface ProjectManagerUpdateParam {
    /**
     * 
     * @type {string}
     * @memberof ProjectManagerUpdateParam
     */
    newIdentityId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectManagerUpdateParam
     */
    invitationEmail?: string;
}

/**
 * Check if a given object implements the ProjectManagerUpdateParam interface.
 */
export function instanceOfProjectManagerUpdateParam(value: object): value is ProjectManagerUpdateParam {
    return true;
}

export function ProjectManagerUpdateParamFromJSON(json: any): ProjectManagerUpdateParam {
    return ProjectManagerUpdateParamFromJSONTyped(json, false);
}

export function ProjectManagerUpdateParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectManagerUpdateParam {
    if (json == null) {
        return json;
    }
    return {
        
        'newIdentityId': json['newIdentityId'] == null ? undefined : json['newIdentityId'],
        'invitationEmail': json['invitationEmail'] == null ? undefined : json['invitationEmail'],
    };
}

export function ProjectManagerUpdateParamToJSON(value?: ProjectManagerUpdateParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newIdentityId': value['newIdentityId'],
        'invitationEmail': value['invitationEmail'],
    };
}

